import script from "./FraudOps.vue?vue&type=script&setup=true&lang=js"
export * from "./FraudOps.vue?vue&type=script&setup=true&lang=js"

import "./FraudOps.vue?vue&type=style&index=0&id=e0f6e7c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0f6e7c2"]])

export default __exports__